import {LOOM_ACCESS_TOKEN} from "src/constants";

const token = localStorage.getItem(LOOM_ACCESS_TOKEN);

export const fetchSuperStarDropDownOptions= async (selectedStage: string): Promise<{
    domainName: string;
    superStar: string;
}[]>  => {
    try {
        const response = await fetch(`https://ds2apionboarding-${selectedStage.toLowerCase()}.iad.corp.amazon.com/onboardedServices`, {
            method: "GET",
            headers: {
                "Authorization": `Bearer ${token}`,
            },
        });

        const data = await response.json();

        if (Array.isArray(data.OnboardedServices)) {
            console.log('Found array data with length:', data.OnboardedServices.length);
            return data.OnboardedServices;
        }

        return [];
    }
    catch (error) {
        console.error("Error fetching data:", error);
        return [];
    }
}
